<!-- <p>on-board works!</p> -->
 <div class="route-wrapper" [@routeAnimations]="animState" (@routeAnimations.done)="onAnimDone()">
<!-- <div [@routeAnimations]="getAnimationState(outlet)"> -->
    <router-outlet #outlet="outlet"></router-outlet>
 </div>